import SysAdminPatientProfileDetailsComponent from 'components/SysAdmin/SysAdminPatientProfileDetailsComponent/SysAdminPatientProfileDetailsComponent';
import ContainerComponent from 'components/Tool/ContainerComponent/ContainerComponent';
import Footer from 'pages/Client/Footer/Footer';
import Header from 'pages/Client/Header/Header';
import SysAdminMenu, { SysAdminMenuEnum } from 'pages/SysAdmin/SysAdminMenu/SysAdminMenu';
import { useParams } from 'react-router-dom';

function PatientProfileDetails() {
  const { patientProfileId } = useParams();

  if (!patientProfileId) {
    return null;
  }

  return (
    <>
      <div className="sys-admin-user-details layout-full-height">
        <Header />

        <ContainerComponent className="layout-main-content">
          <>
            <SysAdminMenu selectedMenu={SysAdminMenuEnum.USERS} />

            <SysAdminPatientProfileDetailsComponent patientProfileId={patientProfileId} />
          </>
        </ContainerComponent>

        <Footer />
      </div>
    </>
  );
}

export default PatientProfileDetails;